import { IntegratedSelection } from '@devexpress/dx-react-grid';
import { createElement } from 'react';
import { Plugin, Getter } from '@devexpress/dx-react-core';

var IntegratedSelectionWrapper = function IntegratedSelectionWrapper() {
  var allRows;
  return /*#__PURE__*/createElement(Plugin, null, /*#__PURE__*/createElement(Getter, {
    name: "rows",
    computed: function computed(_ref) {
      var rows = _ref.rows;
      allRows = rows;
      return rows.filter(function (row) {
        return row.disabledIndex;
      });
    }
  }), /*#__PURE__*/createElement(IntegratedSelection, null), /*#__PURE__*/createElement(Getter, {
    name: "rows",
    computed: function computed() {
      return allRows;
    }
  }));
};

export { IntegratedSelectionWrapper };